import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

export function trackWelcomeMatPromptClick({ cardName, slotNumber, pageName }) {
    if (!cardName || slotNumber === null || slotNumber === undefined) {
        return;
    }

    const normalizedCardName = cardName.toLowerCase();
    const actionInfo = `superchat:welcome mat:${normalizedCardName}:slot${slotNumber}`;

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            actionInfo,
            pageName: pageName || anaConsts.SUPER_CHAT.SUPERCHAT_LANDING
        }
    });
}
